import { ReactPlugin } from "@microsoft/applicationinsights-react-js"
import { ApplicationInsights, DistributedTracingModes } from "@microsoft/applicationinsights-web"
import { SofiaEnvironment } from "@/sofia-environment.ts"

const reactPlugin = new ReactPlugin()

const AppInsights = new ApplicationInsights({
  config: {
    appId: "web-frontend",
    distributedTracingMode: DistributedTracingModes.AI,
    enableCorsCorrelation: true,
    // When enabling CorsCorrelation, Application Insights will intervene in CORS requests and require some additional response headers like request-context, traceparent.
    // But not all third parties support it. For this case, we need to add it to the excluded domain list below.
    correlationHeaderExcludedDomains: ["dgconsent.de", "consentric.io", "grafana.net"],
    enableAutoRouteTracking: true,
    connectionString: SofiaEnvironment.AppInsights.ConnectionString,
    enableDebug: SofiaEnvironment.Bff.IsDevelopment,
    extensions: [reactPlugin],
    maxAjaxCallsPerView: -1, // no limit since we got errors because of that on local
  },
})

const patientFileRegex = /^\/patients\/(DE|CH)\/.*$/

AppInsights.addTelemetryInitializer((envelope) => {
  // Remove patient name from the page name
  if (
    (envelope.baseType === "PageviewData" || envelope.baseType === "PageviewPerformanceData") &&
    envelope.baseData &&
    patientFileRegex.test(new URL(envelope.baseData.uri).pathname)
  ) {
    envelope.baseData.name = "Patient's file"
  }

  // Add cloud role
  if (!envelope.tags) {
    envelope.tags = []
  }
  // type-coverage:ignore-next-line
  envelope.tags.push({ "ai.cloud.role": AppInsights.config.appId })

  // Add user.id for consistency with OpenTelemetry (backend) spans
  // type-coverage:ignore-next-line
  if (AppInsights.context?.user?.accountId) {
    envelope.tags.push({ "user.id": AppInsights.context.user.accountId })
  }
})

AppInsights.addDependencyListener((details) => {
  if (!details.context) {
    details.context = []
  }
  if (typeof details.input !== "string" || !details.input) {
    return
  }
  if (!details.input.includes("api/graphql")) {
    return
  }

  const jsonBody = details.init?.body
  if (!jsonBody) {
    return
  }

  // type-coverage:ignore-next-line
  // Hack to have the operation name instead of just "FETCH /api/graphql"
  const body = JSON.parse(jsonBody.toString())
  // type-coverage:ignore-next-line
  if (body?.operationName) {
    // type-coverage:ignore-next-line
    details.context["operationName"] = body.operationName
  }
})

AppInsights.addDependencyInitializer((details) => {
  // Hack to have the operation name instead of just "FETCH /api/graphql"
  if (details.context?.["operationName"]) {
    details.item.name = details.context["operationName"]
    details.item.type = "GraphQL"
  }
})

if (!SofiaEnvironment.Bff.IsAutomatedTest) {
  AppInsights.loadAppInsights()
}

export { AppInsights }
